import { createSelector } from 'reselect'
import { getCurrency } from '../../currency/selectors/currency'
import { IStore } from '../../index'

export function getUserObjectId(state: IStore) {
  return state.object.userObjectId
}

export function getObjectStatus(state: IStore) {
  return state.object.profileRequest
}

export function getFinanceStatus(state: IStore) {
  return state.object.financeRequest
}

export const getPrepayments = (state: IStore) =>
  state.object.userObject.settings.provision
export const getPrepaymentType = (state: IStore) =>
  state.object.userObject.settings.prepayment_type

export function getUserPriceListVersion(state: IStore) {
  return state.object.userObject.profile
    ? state.object.userObject.profile.pricelistVersion
    : undefined
}

export function getUserProfileLoading(state: IStore) {
  return state.object.profileRequest.isLoading
}

export function getProfileObject(state: IStore) {
  return state.object.userObject.profile
}

export const getUserCurrency = createSelector(
  [getProfileObject, getCurrency],
  (settings, currency) =>
    currency && settings
      ? currency.filter(
          cur => Number(cur.id) === Number(settings.idCurrency),
        )[0].name
      : undefined,
)

export function getObjectType(state: IStore) {
  return state.object.objectType
}

export function getCountryDict(state: IStore) {
  return state.object.countryDictionary
}

export function getObjectCurrency(state: IStore) {
  return state.object.userObject.profile
    ? state.object.userObject.profile.idCurrency
    : 1
}
